/* Mirrors TARGET_TYPE_CHOICES on the backend. Kept in one place so the add
   page and the edit dialog cannot drift apart - they each carried their own
   invented list before ("Conversions", "Target login hours", "Resolved
   cases", "New connections"), none of which the API accepts. */
export const TARGET_TYPE_CHOICES = [
  { value: "calls", label: "Calls" },
  { value: "callback_to_ptp", label: "Callback to PTP" },
  { value: "ptp_to_paid", label: "PTP to Paid" },
  { value: "pos", label: "POS" },
  { value: "home_visit", label: "Home Visit" },
];

/* A row may carry the stored code ("ptp_to_paid") or the label the list
   endpoint returns ("PTP to Paid"); this resolves either to the code. */
export const toTargetTypeValue = (input) => {
  if (!input) return undefined;
  const raw = String(input).trim();
  const byValue = TARGET_TYPE_CHOICES.find(
    (choice) => choice.value.toLowerCase() === raw.toLowerCase()
  );
  if (byValue) return byValue.value;
  const byLabel = TARGET_TYPE_CHOICES.find(
    (choice) => choice.label.toLowerCase() === raw.toLowerCase()
  );
  return byLabel ? byLabel.value : undefined;
};

export const targetTypeLabel = (input) => {
  const value = toTargetTypeValue(input);
  const choice = TARGET_TYPE_CHOICES.find((item) => item.value === value);
  /* an unrecognised code is shown as-is rather than blanked out */
  return choice ? choice.label : input || "";
};
